import { render, staticRenderFns } from "./skillStars.vue?vue&type=template&id=423f0f25&scoped=true"
import script from "./skillStars.vue?vue&type=script&lang=js"
export * from "./skillStars.vue?vue&type=script&lang=js"
import style0 from "./skillStars.vue?vue&type=style&index=0&id=423f0f25&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "423f0f25",
  null
  
)

export default component.exports